import { render, staticRenderFns } from "./ModalsPage.vue?vue&type=template&id=6765ce72&scoped=true&"
import script from "./ModalsPage.vue?vue&type=script&lang=js&"
export * from "./ModalsPage.vue?vue&type=script&lang=js&"
import style0 from "./ModalsPage.vue?vue&type=style&index=0&id=6765ce72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6765ce72",
  null
  
)

export default component.exports